import { render } from "./rentasvestido.vue?vue&type=template&id=7d7a8cea&scoped=true"
import script from "./rentasvestido.vue?vue&type=script&lang=js"
export * from "./rentasvestido.vue?vue&type=script&lang=js"

import "./rentasvestido.vue?vue&type=style&index=0&id=7d7a8cea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d7a8cea"]])

export default __exports__